import React from 'react';
import { Text } from 'ink';
import { Markdown } from './Markdown';

interface ControlsHintProps {
  children: string;
  availableWidth?: number;
}

export const ControlsHint: React.FC<ControlsHintProps> = ({ children, availableWidth }) => {
  return (
    <Text dimColor>
      <Markdown markdown={children} availableWidth={availableWidth} />
    </Text>
  );
};
